import React from 'react';
import { Text, VStack } from '@adc/parallax-component-library';
import { usePartner } from 'Hooks';
import { Button, Main, ResponsiveContainer } from 'Components/utility';
import i18n from 'Utilities/i18n';
const ResetPasswordSecondStep = () => {
    const { partner, handleResetPasswordDone } = usePartner();
    return (React.createElement(Main, null,
        React.createElement("img", { src: i18n.t('Global.microcopy.common.libreLogoLight'), alt: "", id: "Global.microcopy.common.libreLogo", style: {
                position: 'absolute',
                zIndex: 1,
                marginTop: '20px',
                width: '100px',
                height: '50px',
                objectFit: 'contain',
                left: '50%',
                transform: 'translateX(-50%)',
            } }),
        React.createElement(ResponsiveContainer, null,
            React.createElement("img", { src: i18n.t('ResetPasswordSuccessful.content.ResetPasswordSuccessfulMessage.media.passwordResetSuccess'), alt: "", id: "ResetPasswordSuccessful.content.ResetPasswordSuccessfulMessage.media.passwordResetSuccess", style: {
                    marginTop: '40px',
                    height: '105px',
                    objectFit: 'contain',
                } }),
            React.createElement(VStack, { marginTop: "$7", gridRowGap: "$2", width: "100%", display: "flex", alignItems: "center", justifyContent: "center" },
                React.createElement(Text, { testID: "ResetPasswordSuccessful.content.ResetPasswordSuccessfulMessage.primaryText", fontWeight: '$h2.strong', fontSize: "$h2.strong", color: "$text.100", display: "flex", flexDirection: "column", textAlign: "center" }, i18n.t('ResetPasswordSuccessful.content.ResetPasswordSuccessfulMessage.primaryText')),
                React.createElement(Text, { testID: "ResetPasswordSuccessful.content.ResetPasswordSuccessfulMessage.secondaryText", fontWeight: "$bodyBase.default", fontSize: "$bodyBase.default", color: "$text.100", display: "flex", flexDirection: "column", textAlign: "center" }, i18n.t('ResetPasswordSuccessful.content.ResetPasswordSuccessfulMessage.secondaryText'))),
            React.createElement(VStack, { width: "90%", marginHorizontal: "auto", marginTop: "$12" },
                React.createElement(Button, { onPress: handleResetPasswordDone, testID: "ResetPasswordSuccessful.backToPartner", label: i18n.t('ResetPasswordSuccessful.microcopy.ButtonTextSet.backToPartner', {
                        partnerName: partner.displayName,
                    }), "aria-label": i18n.t('ResetPasswordSuccessful.microcopy.ButtonTextSet.backToPartner', {
                        partnerName: partner.displayName,
                    }) })))));
};
export default ResetPasswordSecondStep;
